<template>
	<div class="login">
		<div class="title">登录</div>
		<div class="tips">欢迎加入福建省民族管弦乐学会！</div>

		<div class="form">
			<div class="login-input flex flex-align-center flex-jus-center">
				<img src="../../static/images/icon-user.png" class="user" />
				<input type="tel" maxlength="11" class="flex-1" placeholder="请输入您的手机号"  v-model="mobile"/>
			</div>
			<div class="login-input flex flex-align-center flex-jus-between">
				<div class="flex flex-align-center">
					<img src="../../static/images/icon-ver.png" class="ver" />
					<input class="codeInput" type="tel" placeholder="请输入验证码" v-model="code" maxlength="6"/>
				</div>
				<div class="flex flex-align-center">
					<div>|</div>
					<div class="verCodeDes" @click="getCode" v-if="!sec">获取验证码</div>
					<div class="verCodeDes" v-else>{{ sec }}s</div>
				</div>
			</div>
		</div>

		<div class="finish" @click="finish">完成</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			sec: 0,
			timer: null,
			
			mobile: '',
			code: '',
			ticket: '',
			scene: 'login'
		};
	},
	beforeCreate() {
		// let mobile = localStorage.getItem('mobile')
		// if (mobile!='undefined' && mobile!='' && mobile!=undefined && mobile!=null) this.$router.replace({'name': 'home'})
	},
	created() {},
	beforeDestroy() {
		clearInterval(this.timer)
	},
	mounted() {},
	methods: {
		finish() {
			this.$post('api/user/userBing', {
				mobile: this.mobile,
				code: this.code,
				ticket: this.ticket,
				scene: this.scene
			}).then(res => {
				if (res.code == 2000) {
					localStorage.setItem('mobile', this.mobile)
					// this.$toast.success('绑定成功！')
					this.$router.replace({'name': 'home'})
				} else {
					// this.$toast.fail('请检查手机号和验证码！')
					this.$toast.fail(res.msg)
				}
			})
		},
		// 获取验证码
		getCode() {
			
			let regx = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
			// return regx.test(num)
			if (!regx.test(this.mobile)) {
				this.$toast.fail('请输入正确手机号！')
				return
			}
			
			this.$post('aliyun/sms/sendSmsCode',{
				scene: 'login',
				mobile: this.mobile
			}).then(res => {
				if (res.code != 0) {
					this.ticket = res.data.ticket
					clearInterval(this.timer)
					this.sec = 60
					this.timer = setInterval(() => {
						this.sec--
						if (this.sec == 0) clearInterval(this.timer)
					},1000)
				} else {
					this.$toast.fail(res.msg)
				}
				
			})
			
		}
	}
};
</script>

<style scoped lang="stylus">
.login
	padding 58px 66px
	.title
		width 100%
		font-size 60px
		font-weight bold
		line-height 84px
		color #333333
	.tips
		width 100%
		margin-top 16px
		font-size 26px
		color #A8A8A8
		margin-bottom 122px
	.login-input
		margin-top 40px
		width 100%
		height: 88px;
		padding 26px 40px
		padding-right 0
		border: 2px solid #F1F1F1;
		border-radius: 44px;
		font-size: 26px;
		color: #A8A8A8;
		.user
			width 36px
			height 36px
			margin-right 24px
		.codeInput
			width 200px
		.ver
			width 32px
			height 36px
			margin-right 24px
		.verCodeDes
			width: 210px;
			text-align center
			font-size: 26px;
			color: #DE113C;
	.finish
		margin 120px auto
		width: 566px;
		height: 84px;
		line-height 84px
		text-align center
		background: #DE113C;
		border-radius: 46px;
		font-size: 32px;
		color: #FFFFFF;
</style>
